// The Insights assistant saves workflow_status_id as a string and the filter
// editor saves it as a number. Dropdown options carry the number, and both the
// dropdown and the label lookup match with ===, so a string id selects nothing
// and the user sees no status in a filter that holds one.
export function toWorkflowStatusId(
  value: number | string | null | undefined
): number | string | null {
  if (typeof value !== 'string' || value.trim() === '') return value ?? null

  const id = Number(value)
  return Number.isNaN(id) ? value : id
}
